import React from "react";
import { useRouter } from "../../../context/Router";
import { useTranslation } from "react-i18next";
import { useFocusable } from "../../../utils/Helpers";
export var AuthBackButtonView = function (_a) {
    var focusRaw = _a.focusRaw;
    var navigate = useRouter().navigate;
    var t = useTranslation().t;
    var ref = useFocusable({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () { return navigate("auth"); },
    });
    return (React.createElement("button", { ref: ref, tabIndex: 0, className: "auth-back-btn" }, t("login.back")));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/auth/AuthBackButtonView.tsx
// module id = 172
// module chunks = 1